<template>
    <div class="push-log-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-message"></i>
                    <span>消息推送日志</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="query" class="filter-form">
                <el-form-item label="学生姓名">
                    <el-input clearable v-model="query.studentName" placeholder="请输入学生姓名" style="width: 140px"></el-input>
                </el-form-item>
                <el-form-item label="学号">
                    <el-input clearable v-model="query.studentNo" placeholder="请输入学号" style="width: 140px"></el-input>
                </el-form-item>
                <el-form-item label="家长姓名">
                    <el-input clearable v-model="query.parentName" placeholder="请输入家长姓名" style="width: 140px"></el-input>
                </el-form-item>
                <el-form-item label="推送状态">
                    <el-select clearable v-model="query.pushStatus" placeholder="全部状态" style="width: 120px">
                        <el-option label="待推送" value="PENDING"></el-option>
                        <el-option label="推送成功" value="SUCCESS"></el-option>
                        <el-option label="推送失败" value="FAIL"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务类型">
                    <el-select clearable v-model="query.businessType" placeholder="全部类型" style="width: 120px">
                        <el-option label="签到" value="SIGN_IN"></el-option>
                        <el-option label="请假" value="LEAVE"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="推送时间">
                    <el-date-picker
                        v-model="pushTimeRange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 360px">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                </div>
                <div class="card-header-right">
                    <el-button
                        type="success"
                        size="small"
                        icon="el-icon-s-promotion"
                        @click="handleTestPush">
                        测试推送
                    </el-button>
                    <el-button
                        type="warning"
                        size="small"
                        icon="el-icon-refresh"
                        :disabled="selectedIds.length === 0"
                        @click="handleBatchRetry">
                        批量重推（{{ selectedIds.length }}）
                    </el-button>
                    <el-button
                        type="danger"
                        size="small"
                        icon="el-icon-delete"
                        :disabled="selectedIds.length === 0"
                        @click="handleBatchDelete">
                        批量删除（{{ selectedIds.length }}）
                    </el-button>
                </div>
            </div>
            <el-table
                ref="table"
                :data="list"
                border
                stripe
                v-loading="tableLoading"
                element-loading-text="加载中..."
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50" align="center"/>
                <el-table-column type="index" label="序号" width="80" align="center"/>
                <el-table-column prop="studentId" label="学生ID" width="80" align="center"/>
                <el-table-column prop="parentId" label="家长ID" width="80" align="center"/>
                <el-table-column prop="businessType" label="业务类型" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small" effect="plain"
                            :type="scope.row.businessType === 'SIGN_IN' ? 'primary' : scope.row.businessType === 'LEAVE' ? 'warning' : 'info'">
                            {{ scope.row.businessType === 'SIGN_IN' ? '签到' : scope.row.businessType === 'LEAVE' ? '请假' : scope.row.businessType || '-' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="businessId" label="业务ID" width="80" align="center"/>
                <el-table-column prop="pushStatus" label="推送状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small" effect="plain"
                            :type="scope.row.pushStatus === 'SUCCESS' ? 'success' : scope.row.pushStatus === 'FAIL' ? 'danger' : scope.row.pushStatus === 'PENDING' ? 'warning' : 'info'">
                            {{ scope.row.pushStatus === 'SUCCESS' ? '成功' : scope.row.pushStatus === 'FAIL' ? '失败' : scope.row.pushStatus === 'PENDING' ? '待推送' : scope.row.pushStatus || '-' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="pushContent" label="推送内容" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="preview-text">{{ truncateContent(scope.row.pushContent) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="errorMsg" label="错误信息" min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.errorMsg" class="error-msg">{{ scope.row.errorMsg }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="wechatMsgId" label="微信MsgID" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.wechatMsgId || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pushTime" label="推送时间" width="170" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.pushTime || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="170" align="center"/>
                <el-table-column align="center" label="操作" width="140" fixed="right">
                    <template slot-scope="scope">
                        <div class="action-btns">
                            <el-button type="primary" size="mini" icon="el-icon-view" @click="handleView(scope.row)">详情</el-button>
                            <el-button
                                v-if="scope.row.pushStatus === 'FAIL'"
                                type="warning"
                                size="mini"
                                icon="el-icon-refresh"
                                @click="handleRetry(scope.row)">重推</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 查看详情对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            title="推送日志详情"
            :visible.sync="dialogVisible"
            width="700px"
            class="push-log-dialog">
            <el-form :model="detail" label-width="90px" v-if="detail">
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="学生ID">
                            <el-input :value="detail.studentId" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="家长ID">
                            <el-input :value="detail.parentId || '-'" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="业务类型">
                            <el-tag size="small" effect="plain"
                                :type="detail.businessType === 'SIGN_IN' ? 'primary' : detail.businessType === 'LEAVE' ? 'warning' : 'info'">
                                {{ detail.businessType === 'SIGN_IN' ? '签到' : detail.businessType === 'LEAVE' ? '请假' : detail.businessType || '-' }}
                            </el-tag>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="业务ID">
                            <el-input :value="detail.businessId" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="模板ID">
                            <el-input :value="detail.templateId || '-'" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="微信MsgID">
                            <el-input :value="detail.wechatMsgId || '-'" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="推送状态">
                            <el-tag size="small" effect="plain"
                                :type="detail.pushStatus === 'SUCCESS' ? 'success' : detail.pushStatus === 'FAIL' ? 'danger' : detail.pushStatus === 'PENDING' ? 'warning' : 'info'">
                                {{ detail.pushStatus === 'SUCCESS' ? '成功' : detail.pushStatus === 'FAIL' ? '失败' : detail.pushStatus === 'PENDING' ? '待推送' : detail.pushStatus || '-' }}
                            </el-tag>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="推送时间">
                            <el-input :value="detail.pushTime || '-'" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="创建时间">
                            <el-input :value="detail.createTime" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="推送内容">
                    <el-input type="textarea" :value="detail.pushContent || '无内容'" disabled :rows="4"></el-input>
                </el-form-item>
                <el-form-item v-if="detail.errorMsg" label="错误信息">
                    <el-input type="textarea" :value="detail.errorMsg" disabled :rows="3" class="error-input"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
                <el-button
                    v-if="detail && detail.pushStatus === 'FAIL'"
                    type="warning"
                    @click="handleRetryFromDialog">重新推送</el-button>
            </div>
        </el-dialog>

        <!-- 测试推送对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            title="测试推送模板消息"
            :visible.sync="testDialogVisible"
            width="520px">
            <el-form :model="testForm" label-width="100px">
                <el-form-item label="模板类型">
                    <el-select v-model="testForm.templateScene" placeholder="请选择模板" style="width: 100%" @change="onTemplateChange">
                        <el-option label="签到通知 (SIGN_IN)" value="SIGN_IN"></el-option>
                        <el-option label="排队叫号 (QUEUING)" value="QUEUING"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="家长OpenID">
                    <el-input
                        v-model="testForm.openid"
                        placeholder="请输入家长的微信openid"
                        clearable>
                    </el-input>
                </el-form-item>

                <!-- 排队叫号模板专属字段 -->
                <template v-if="testForm.templateScene === 'QUEUING'">
                    <el-form-item label="店铺名称">
                        <el-input v-model="testForm.shopName" placeholder="请输入店铺名称 (thing2)" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="排队区域">
                        <el-input v-model="testForm.queueArea" placeholder="请输入排队区域 (thing7)" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="排队桌名">
                        <el-input v-model="testForm.tableName" placeholder="请输入排队桌名 (thing9)" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="排队时间">
                        <el-input v-model="testForm.queueTime" placeholder="yyyy-MM-dd HH:mm (time3)" clearable></el-input>
                    </el-form-item>
                </template>

                <!-- 签到模板提示 -->
                <template v-if="testForm.templateScene === 'SIGN_IN'">
                    <el-alert
                        title="签到模板字段"
                        type="info"
                        :closable="false"
                        show-icon
                        style="margin-top: 8px">
                        <div slot="description">
                            thing2 (机构名称): 自动获取机构名称<br/>
                            thing7 (学生姓名-签到): 测试学生-签到<br/>
                            thing9 (剩余课时): 剩余课时（30）<br/>
                            time3 (签到时间): 当前时间
                        </div>
                    </el-alert>
                </template>

                <el-alert
                    title="家长openid获取方式"
                    type="info"
                    :closable="false"
                    show-icon
                    style="margin-top: 8px">
                    <div slot="description">
                        1. 家长关注公众号后，在 message_push_log 表的 errorMsg 或数据库中查找<br/>
                        2. 也可以让家长在公众号发送消息，在微信后台查看
                    </div>
                </el-alert>
            </el-form>
            <div slot="footer">
                <el-button @click="testDialogVisible = false">取消</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-s-promotion"
                    :loading="testLoading"
                    @click="doTestPush">发送测试消息</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { reqPushLogPage, reqPushLogDetail, reqPushLogRetry, reqPushLogBatchRetry, reqTestPush, reqBatchDelete } from '@/api/education/message-push-log'

export default {
    name: 'MessagePushLog',
    data() {
        return {
            list: [],
            total: 0,
            tableLoading: false,
            selectedIds: [],
            pushTimeRange: [],
            query: {
                currentPage: 1,
                pageSize: 10,
                studentName: '',
                studentNo: '',
                parentName: '',
                pushStatus: null,
                businessType: null,
                pushTimeStart: null,
                pushTimeEnd: null
            },
            dialogVisible: false,
            detail: null,
            // 测试推送
            testDialogVisible: false,
            testLoading: false,
            testForm: {
                templateScene: 'SIGN_IN',
                openid: '',
                shopName: '测试店铺',
                queueArea: '一楼大厅',
                tableName: 'A01桌',
                queueTime: ''
            }
        }
    },
    created() {
        this.load()
    },
    methods: {
        async load() {
            this.tableLoading = true
            // 处理时间范围
            if (this.pushTimeRange && this.pushTimeRange.length === 2) {
                this.query.pushTimeStart = this.pushTimeRange[0]
                this.query.pushTimeEnd = this.pushTimeRange[1]
            } else {
                this.query.pushTimeStart = null
                this.query.pushTimeEnd = null
            }
            try {
                const data = await reqPushLogPage(this.query)
                this.list = data.records || []
                this.total = data.total || 0
            } catch (e) {
                this.$message.error('加载推送日志失败')
                console.error(e)
            } finally {
                this.tableLoading = false
            }
        },
        handleSearch() {
            this.query.currentPage = 1
            this.load()
        },
        handleReset() {
            this.query = {
                currentPage: 1,
                pageSize: 10,
                studentName: '',
                studentNo: '',
                parentName: '',
                pushStatus: null,
                businessType: null,
                pushTimeStart: null,
                pushTimeEnd: null
            }
            this.pushTimeRange = []
            this.load()
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        sizeChange(size) {
            this.query.pageSize = size
            this.query.currentPage = 1
            this.load()
        },
        handleSelectionChange(selection) {
            this.selectedIds = selection.map(item => item.id)
        },
        canRetry(row) {
            return row.pushStatus === 'FAIL'
        },
        async handleView(row) {
            try {
                const res = await reqPushLogDetail(row.id)
                this.detail = res.data || row
            } catch (e) {
                this.detail = row
            }
            this.dialogVisible = true
        },
        handleRetry(row) {
            this.$confirm('确认重新推送此条消息吗？仅支持重推当日签到的失败记录。', '重推确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    await reqPushLogRetry(row.id)
                    this.$message.success('已重新推送')
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '推送失败')
                }
            }).catch(() => {})
        },
        handleRetryFromDialog() {
            this.dialogVisible = false
            this.handleRetry(this.detail)
        },
        handleBatchRetry() {
            if (this.selectedIds.length === 0) {
                this.$message.warning('请选择要重推的记录')
                return
            }
            this.$confirm(`确认批量重新推送 ${this.selectedIds.length} 条失败记录吗？仅支持重推当日签到的失败记录。`, '批量重推', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await reqPushLogBatchRetry(this.selectedIds)
                    const { success, fail } = res.data
                    this.$message.success(`批量重推完成：成功 ${success} 条，失败 ${fail} 条`)
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '批量重推失败')
                }
            }).catch(() => {})
        },
        handleBatchDelete() {
            if (this.selectedIds.length === 0) {
                this.$message.warning('请选择要删除的记录')
                return
            }
            this.$confirm(`确认删除选中的 ${this.selectedIds.length} 条推送日志吗？删除后不可恢复。`, '批量删除', {
                confirmButtonText: '确定删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await reqBatchDelete(this.selectedIds)
                    if (res.code === 200 || res.code === 0) {
                        this.$message.success(res.message || res.msg || `成功删除 ${this.selectedIds.length} 条记录`)
                    } else {
                        this.$message.error(res.message || res.msg || '删除失败')
                    }
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '批量删除失败')
                }
            }).catch(() => {})
        },
        truncateContent(content) {
            if (!content) return '-'
            return content.length > 50 ? content.substring(0, 50) + '...' : content
        },
        handleTestPush() {
            this.testForm.templateScene = 'QUEUING'
            this.testForm.openid = 'o_pb222bfYI8VKnoNMmKaX2zMmZw'
            this.testForm.shopName = '测试店铺'
            this.testForm.queueArea = '一楼大厅'
            this.testForm.tableName = 'A01桌'
            // 默认排队时间为当前时间
            const now = new Date()
            this.testForm.queueTime = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + ' ' +
                String(now.getHours()).padStart(2, '0') + ':' +
                String(now.getMinutes()).padStart(2, '0')
            this.testDialogVisible = true
        },
        onTemplateChange(val) {
            // 切换模板时可以重置默认值
        },
        async doTestPush() {
            if (!this.testForm.openid.trim()) {
                this.$message.warning('请输入家长openid')
                return
            }
            this.testLoading = true
            try {
                const params = {
                    openid: this.testForm.openid.trim(),
                    templateScene: this.testForm.templateScene
                }
                if (this.testForm.templateScene === 'QUEUING') {
                    params.shopName = this.testForm.shopName
                    params.queueArea = this.testForm.queueArea
                    params.tableName = this.testForm.tableName
                    params.queueTime = this.testForm.queueTime
                }
                const res = await reqTestPush(params)
                if (res.code === 200 || res.code === 0) {
                    this.$message.success(res.message || res.msg || '测试推送成功')
                    this.testDialogVisible = false
                    this.load()
                } else {
                    this.$message.error(res.message || res.msg || '测试推送失败')
                }
            } catch (e) {
                this.$message.error(e.message || '测试推送失败')
            } finally {
                this.testLoading = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.push-log-page {
    padding: 0;

    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                color: #409eff;
            }

            .header-sub {
                font-size: 13px;
                font-weight: 500;
                color: #909399;
            }

            .total-badge {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;

                b {
                    color: #409eff;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        .card-header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .filter-form {
        padding: 4px 0 0;

        ::v-deep .el-form-item {
            margin-bottom: 8px;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .action-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        white-space: nowrap;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    .preview-text {
        font-size: 12px;
        color: #909399;
    }

    .error-msg {
        color: #f56c6c;
    }

    ::v-deep .el-divider--vertical {
        height: 1.2em;
        margin: 0 4px;
    }

    ::v-deep .el-table {
        th {
            background: #fafafa;
            color: #606266;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-size: 13px;
        }

        .el-tag--plain {
            font-weight: 500;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px;
        overflow: hidden;

        .el-dialog__header {
            padding: 16px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .el-dialog__body {
            padding: 24px 30px 8px;
        }

        .el-dialog__footer {
            padding: 14px 30px;
            border-top: 1px solid #ebeef5;
        }
    }

    .error-input ::v-deep .el-textarea__inner {
        color: #f56c6c;
        background: #fef0f0;
    }
}

@media screen and (max-width: 768px) {
    .push-log-page {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }

        .filter-form {
            ::v-deep .el-form--inline .el-form-item {
                display: block;
                width: 100%;
                margin-bottom: 12px;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content {
                width: 100%;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-select,
            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-input,
            ::v-deep .el-form--inline .el-form-item .el-date-picker {
                width: 100% !important;
            }
        }

        ::v-deep .el-card__body {
            padding: 12px;
        }

        ::v-deep .el-table {
            overflow-x: auto;
            display: block;
        }

        ::v-deep .el-dialog {
            width: 95% !important;
            margin: 10px auto !important;
        }

        ::v-deep .el-dialog__body {
            padding: 16px;
        }

        ::v-deep .el-dialog__footer {
            padding: 12px 16px;
        }

        ::v-deep .el-pagination {
            white-space: normal;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 4px;
        }

        ::v-deep .el-pagination .el-pagination__total,
        ::v-deep .el-pagination .el-pagination__sizes {
            margin-right: 0;
        }

        ::v-deep .el-pagination button,
        ::v-deep .el-pagination .el-pager li {
            min-width: 28px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
        }
    }
}
</style>
